/**
 * @module
 * @category State
 */

import { devtools, persist } from '@bomdisoft/store/middleware';
import { create } from '@bomdisoft/store/react';

type ProgressStore = {
  processing: boolean;
  setProcessing: (processing: boolean) => void;
  toggleProcessing: () => void;
};

export const useProgressStore = create<ProgressStore>()(
  devtools(
    persist(
      (set, _get) => ({
        processing: false,
        setProcessing: (processing: boolean) => {
          set({ processing });
        },
        toggleProcessing: () => {
          set(state => ({ processing: !state.processing }));
        },
      }),
      { name: 'bomdisoft-progress-storage' },
    ),
  ),
);
